const STEPS = [
  { label: '動画をアップロード', detail: '送りたい動画を選んでアップロードします。' },
  { label: '共有リンクを送る', detail: '発行したリンクを相手に送ります。' },
  { label: '相手が受け取る', detail: '相手はリンクを開くだけ。登録は必要ありません。' },
] as const

export function LandingSteps() {
  return (
    <section className="border-t border-border bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-center">
          動画を選んで、リンクを送るだけ
        </h2>
        <div className="relative mt-14">
          <div
            aria-hidden
            className="absolute left-[17%] right-[17%] top-8 hidden border-t-2 border-dashed border-primary/15 sm:block"
          />
          <ol className="relative grid gap-8 sm:grid-cols-3 sm:gap-6">
            {STEPS.map((step, index) => (
              <li key={step.label} className="relative text-center">
                <span className="relative mx-auto flex size-16 items-center justify-center rounded-2xl border border-primary/15 bg-white font-mono text-2xl font-bold text-primary shadow-lg shadow-primary/10">
                  0{index + 1}
                </span>
                <p className="mt-6 text-lg font-bold tracking-tight">{step.label}</p>
                <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground">
                  {step.detail}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
